import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

const LAYER_THUMBNAILS = {
  satellite: "/static/images/thumbnails/satellite.png",
  topographic: "/static/images/thumbnails/topographic.png"
}

const BaseLayerControl = ({ baseLayers, onLayerChange }) => {
  const { t } = useTranslation()

  const [timeControlsHeight, setTimeControlsHeight] = useState(0)

  useEffect(() => {
    const timeControls = document.querySelector(".leaflet-bottom.leaflet-left")
    if (!timeControls) return

    const observer = new ResizeObserver(([entry]) => {
      setTimeControlsHeight(entry.contentRect.height)
    })

    observer.observe(timeControls)
    return () => observer.disconnect()
  }, [])

  const nextLayer = baseLayers.find(l => !l.checked)

  if (!nextLayer) return null

  const handleClick = () => {
    onLayerChange(nextLayer, "baseLayers", "radio")
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        bottom: timeControlsHeight + 16,
        left: 8,
        zIndex: 1,
        margin: "-5px -5px -5px 0"
      }}
    >
      <div
        onClick={handleClick}
        title={`${t("Switch_to")} ${t(nextLayer.name)}`}
        className="leaflet-left"
        style={{
          width: 66,
          height: 66,
          borderRadius: 6,
          overflow: "hidden",
          cursor: "pointer",
          border: "2px solid white",
          boxShadow: "0 1px 5px rgba(0,0,0,0.4)",
          position: "relative",
        }}
      >
        <img
          src={LAYER_THUMBNAILS[nextLayer.key]}
          alt={t(nextLayer.name)}
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
        />
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            background: "rgba(0,0,0,0.52)",
            color: "#fff",
            fontSize: 9,
            fontWeight: 500,
            textAlign: "center",
            padding: "2px 2px 3px",
            letterSpacing: "0.02em",
            pointerEvents: "none",
          }}
        >
          {t(nextLayer.name)}
        </div>
      </div>
    </div>
  )
}

export default BaseLayerControl